


























import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator'
import DialogFullscreen from 'components/modals/Fullscreen.vue'
import api from 'src/assets/api/gql'
import StudentGroupUpdate from 'src/graphql/student_group/StudentGroupUpdate.gql'
import { Item, StudentGroup } from 'src/graphql/types'

@Component({
  components: {
    DialogFullscreen
  }
})
export default class ItemCourseStudentGroupButtonEdit extends Vue {

  @Prop()
  readonly group!: StudentGroup

  @Ref()
  readonly dialog!: DialogFullscreen

  async changeName (value: string) {
    const name = value.trim()
    if (name) {
      if (name !== this.group.name) {
        const { data: { updateStudentGroup } } = await api.mutate({
          query: StudentGroupUpdate,
          variables: {
            id: this.group.id,
            data: { name }
          }
        })
        if (updateStudentGroup) {
          this.$emit('set', updateStudentGroup.studentGroup)
        }
      }
    }
  }
}
